import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { money } from "@/lib/format";
import { Loader2, ShoppingCart, Clock, CheckCircle2, ChefHat, Store, Truck, Building2, DollarSign, PackageCheck } from "lucide-react";

const CARDS = [
  { key: "new_orders", label: "New Orders Today", icon: ShoppingCart },
  { key: "awaiting_payment", label: "Awaiting Payment", icon: Clock },
  { key: "payment_submitted", label: "Payment Submitted", icon: Clock },
  { key: "paid_orders", label: "Paid Orders", icon: CheckCircle2 },
  { key: "preparing", label: "Preparing", icon: ChefHat },
  { key: "delivery_orders", label: "Delivery Orders", icon: Truck },
  { key: "completed_orders", label: "Completed", icon: PackageCheck },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <AdminLayout>
      <h1 className="font-serif text-3xl text-cream mb-2">Dashboard</h1>
      <p className="text-cream/50 mb-8">Today's overview at a glance.</p>

      {!stats ? (
        <div className="flex justify-center py-20"><Loader2 className="animate-spin text-gold" size={36} /></div>
      ) : (
        <>
          <div className="gold-border-card rounded-2xl bg-gradient-to-br from-burgundy to-burgundy-dark p-6 mb-6 flex items-center justify-between" data-testid="revenue-card">
            <div>
              <p className="text-cream/70 text-sm flex items-center gap-2"><DollarSign size={16} className="text-gold" /> Today's Revenue (confirmed)</p>
              <p className="font-mono text-gold text-4xl font-bold mt-1">{money(stats.today.today_revenue)}</p>
            </div>
            <p className="text-cream/50 text-sm">{stats.total_orders} total orders</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {CARDS.map((c) => (
              <div key={c.key} className="gold-border-card rounded-xl bg-card-surface p-5" data-testid={`stat-${c.key}`}>
                <c.icon className="text-gold mb-2" size={22} />
                <p className="font-mono text-cream text-3xl font-bold">{stats.today[c.key]}</p>
                <p className="text-cream/50 text-xs mt-1">{c.label}</p>
              </div>
            ))}
          </div>

          <div className="mt-8">
            <Link to="/admin/orders" className="btn-gold inline-block rounded-full px-6 py-3 font-semibold text-sm" data-testid="dashboard-view-orders">Manage Orders →</Link>
          </div>
        </>
      )}
    </AdminLayout>
  );
}
